import ServicePageTemplate from '../../components/sections/ServicePageTemplate';
import { SERVICE_PAGES } from '../../config/servicePagesData';

export default function SupportMaintenancePage() {
  return <ServicePageTemplate service={SERVICE_PAGES.supportMaintenance} />;
}
